export const FILENAME_REGEXP = /[/\\?%*:|"<>]/
